<template>
  <keep-alive>
    <component
      :is="componentSelected"
      :containerNumber="containerNumber"
      :idTracking="detail.tmsLiveTrackingLink"
      :dataMaps="dataLink"
      :dataStatus="statusDetail"
    />
  </keep-alive>
</template>

<script>
import SeaFreightTracking from './SeaFreightTracking.vue';
import MapTrackingLink from './MapTrackingLink.vue';
import LandFreightTracking from './LandFreightTracking.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'FreightTracking',
  props: {
    containerNumber: String
  },
  components: {
    SeaFreightTracking,
    LandFreightTracking,
    MapTrackingLink
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      otif: 'shipment/otif',
      isLoadingOtif: 'shipment/otifIsLoading',
      isErrorOtif: 'shipment/errorOtif'
    }),
    componentSelected() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.viewForm = SeaFreightTracking;
      if (this.detail && this.detail.freightMode === 'LAND') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.viewForm = LandFreightTracking;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.statusDetail = [];
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dataLink = '';
        // eslint-disable-next-line vue/no-async-in-computed-properties
        if (this.otif && this.otif.length > 0) {
          // eslint-disable-next-line array-callback-return
          this.otif.filter(item => {
            if (item.tracking_status) {
              // eslint-disable-next-line array-callback-return
              item.tracking_status.filter(element => {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.statusDetail.push(element);
              });
            }
            if (
              item.otif_stat === 'SCHEDULED_OTIF' &&
              item.tracking_link &&
              (this.detail.freightType === 'BARGE' ||
                this.detail.freightType === 'LCT')
            ) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.dataLink = item.tracking_link;
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.viewForm = MapTrackingLink;
            }
            if (item.otif_stat === 'PICKUP' && item.tracking_link) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.dataLink = item.tracking_link;
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.viewForm = MapTrackingLink;
            }
            if (
              item.otif_stat === 'DESTINATION_LOCAL_HANDLING' &&
              item.tracking_link
            ) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.dataLink = item.tracking_link;
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.viewForm = MapTrackingLink;
            }
          });
        }
      }
      return this.viewForm;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/FreightTracking.vue